import { Premium } from '../premium';

export class Sensation extends Premium {
    public static readonly COVER_URL = 'assets/images/plans/premium/sensation-transparent-cover.png';
    public static readonly COVER_URL_MOBILE = 'assets/images/plans/premium/sensation-transparent-cover.png';
}

export const PremiumSubCategories = ['plan_premium_selection', 'plan_premium_entry', 'plan_premium_multiligne'];
